module.exports = __webpack_public_path__ + "img/cam_error_phone.0f461ba5.jpg";